import jvlNProgress from '@/shared/services/nProgress.service.js';

const commonInterceptors = {
  setCommonInterceptors(axiosInstance) {
    axiosInstance.interceptors.request.use(
      (config) => {
        jvlNProgress.start();

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        jvlNProgress.done();
        return response;
      },
      (error) => {
        jvlNProgress.done();
        return Promise.reject(error);
      }
    );
  },

};

export default commonInterceptors;
